import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveyContentContainer from '../components/SurveyContentContainer';
import GenericHomePage from '../components/GenericHomePage';


export const PabsHomeTab = () => {

  return (
    <SurveyPage>
      <SurveyTitleArea />
      <SurveyContentContainer homePage={true}>
        <GenericHomePage dueDate="October 30, 2026" surveyCategoryName="Pension Administration Benchmarking Survey" />
      </SurveyContentContainer>
    </SurveyPage>
  );
};